import { GraphQLError } from 'graphql';
import moment from 'moment';
import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';

const Container = styled(Box)``;

const Message = styled(Box)`
	background: ${(props) => rgba(props.theme.colors.red, 0.1)};
	padding: 20px;
	border-radius: 8px;
	color: ${(props) => props.theme.colors.red};
`;

export default function EvaluationErrorCard(props: {
	error: GraphQLError;
	submission: graphql.EvaluationSubmission;
	lastSaved: Date | null;
}) {
	const { t } = useTranslation();

	const isValidationError =
		(props.error.extensions?.error as { name: string })?.name === 'ValidationError';

	return (
		<Container mb={3}>
			{isValidationError ? (
				<Message>
					{t('evaluations.submission.validation.error')}{' '}
					{props.submission.viewer.hasShared
						? t('evaluations.submission.autosave.submission')
						: t('evaluations.submission.autosave.concept')}{' '}
					{props.lastSaved && (
						<Moment interval={5000} fromNow>
							{moment(props.lastSaved)}
						</Moment>
					)}
					.
				</Message>
			) : (
				<Message>
					{t('evaluations.submission.autosave.error')}{' '}
					{props.submission.viewer.hasShared
						? t('evaluations.submission.autosave.submission')
						: t('evaluations.submission.autosave.concept')}{' '}
					{props.lastSaved && (
						<Moment interval={5000} fromNow>
							{moment(props.lastSaved)}
						</Moment>
					)}
					.
				</Message>
			)}
		</Container>
	);
}
